export const EMPTY_STORE = 'EMPTY_STORE';

export const emptyReduxStore = (): object => {
    return {
        type: EMPTY_STORE
    };
};
